export enum FUNNEL_STEPS {
  START = 'start',
  PREFERENCE = 'preference',
  PRODUCTS = 'products',
  OVERVIEW = 'overview',
  PAYMENT = 'payment',
  CONFIRMATION = 'confirmation',
}

export enum PET_TYPE {
  DOG = 'dog',
  CAT = 'cat',
}

export enum CATEGORIES {
  DRY_FOOD = 'dry_food',
  WET_FOOD = 'wet_food',
  BARF = 'barf',
  SNACKS = 'snacks',
  SUPPLEMENTS = 'supplements',
  HEALTH = 'health',
  CAT_LITTER = 'cat_litter',
  ACCESSORY = 'accessory',
}
